import { render, staticRenderFns } from "./InfoTooltipIcon copy.vue?vue&type=template&id=578f15cd"
import script from "./InfoTooltipIcon copy.vue?vue&type=script&lang=js"
export * from "./InfoTooltipIcon copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports